<template>
	<div class="full" style="box-sizing: border-box;padding: 20px;">
		<el-row style="height: 100%;position: relative;">
			<el-col :span="11" style="height: 100%;position: relative;">
				<div class="full">
					<div class="right_container full">
						<div class="title flex">
							<div>部门列表</div>
						</div>
						<div class="list" style="height: 550px;">
							<div class="list" style="height: 550px;">
								<department-tree ref="onlinedepartmenttree" @select="departmentTreeChange" />
							</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="2" style="height: 100%;position: relative;">
			</el-col>
			<el-col :span="11" style="height: 100%;position: relative;">
				<div class="full right_container flex">
					<div class="right_box flex">
						<div class="title flex">
							<div>在线人员:</div>
							<span v-if="!loading">{{onlinestaff.length}}</span>
							<i v-else class="el-icon-loading"></i>
						</div>
						<div class="list" style="height: 100%;border-bottom: 1px solid #d7dae2;position: relative;">
							<div class="full" style="box-sizing:border-box; border-box;padding: 5px;"
								@click="clearStaff">
								<div @click="staffItemClick(item,index,$event)" class="staff"
									:class="{staff_active:item.active}" v-for="(item,index) in onlinestaff"
									:key="index">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
					<div class="right_box flex">
						<div class="title flex">
							<div>离线人员:</div>
							<span v-if="!loading">{{underlinestaff.length}}</span>
							<i v-else class="el-icon-loading"></i>
						</div>
						<div class="list" style="height: 100%;border-bottom: 1px solid #d7dae2;position: relative;">
							<div class="full" style="box-sizing:border-box; border-box;padding: 5px;"
								@click="clearStaff">
								<div class="staff" :class="{staff_active:item.active}"
									v-for="(item,index) in underlinestaff" :key="index">
									{{item.name}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<style scoped>
	.container {
		position: relative;
		width: 100%;
		height: 600px;
	}

	.middle {
		height: 100%;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.left_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
	}

	.right_container {
		box-sizing: border-box;
		border: 1px solid #d7dae2;
		box-sizing: border-box;
		width: 100%;
		flex-direction: column;
	}

	.right_box {
		position: relative;
		width: 100%;
		height: 50%;
		flex-direction: column;
	}

	.title {
		position: relative;
		width: 100%;
		height: 40px;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		font-size: 18px;

		background: rgb(244, 244, 245);
		border-bottom: 1px solid #d7dae2;
	}

	.list {
		position: relative;
		width: 100%;
		height: 410px;
		overflow: auto;
	}

	.staff {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
	}

	.staff_active {
		background-color: #409EFF;
		color: white;
	}

	.data {
		cursor: pointer;
		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		-o-user-select: none;
		-ms-user-select: none;
		-webkit-touch-callout: none;
	}

	.data_active {
		background-color: #409EFF;
		color: white;
	}
</style>
<script>
	import departmentTree from '@_system/components/formcomponents/common/select/department/tree.vue'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			}
		},
		data() {
			return {
				loading: true,
				currentdepartmentid: null,
				sourceStaff: {},
				onlinestaff: [],
				underlinestaff: [],
				staff: [],
				data: []

			}

		},

		watch: {
			onlinelist(){
				this.flashList()
			}
		},
		computed: {
			onlinelist() {
				// let onlinelist = this.$store.state.system.onlinelist
				let onlinelist = window.onlineList
				let list = []
				if (JSON.stringify(onlinelist) != "{}") {
					for (let i in onlinelist) {
						list.push(onlinelist[i])
					}
				}
				return list
			},
		},
		created() {
			this.listStaff()
		},
		mounted() {

		},
		methods: {
			listStaff() {
				this.$api.staff.list({
					currentPage: -1
				}).then((res) => {
					let list = res.list.filter((item)=>{
						return item.enable == 5
					})
					this.sourceStaff = list
					this.createStaff(list)
					this.loading = false
				})
			},
			departmentTreeChange(e) {
				this.currentdepartmentid = e
				let staff = []
				this.sourceStaff.forEach((item) => {
					if (e.children.indexOf(item.departmentid) != -1) {
						staff.push(item)
					}
				})
				this.createStaff(staff)
			},

			createStaff(list) {
				let staff = []
				let onlinearr = []
				let underlinearr = []
				list.forEach((item) => {
					let index = this.onlinelist.findIndex((_item) => {
						return _item == item.id
					})
					staff.push({
						id: item.id,
						name: item.name,
						departmentid: item.departmentid,
						active: false
					})
					if (index !== -1) {
						onlinearr.push({
							id: item.id,
							name: item.name,
							departmentid: item.departmentid,
							active: false
						})
					} else {
						underlinearr.push({
							id: item.id,
							name: item.name,
							departmentid: item.departmentid,
							active: false
						})
					}
				})
				this.onlinestaff = onlinearr
				this.underlinestaff = underlinearr
				this.staff = staff
			},
			staffItemClick(item, index, e) {
				e.stopPropagation()
				this.clearStaff()
				this.onlinestaff[index].active = true
			},
			clearStaff() {
				this.onlinestaff.forEach((item) => {
					item.active = false
				})
			},
			getActiveStaff() {
				let obj = null
				this.onlinestaff.forEach((item) => {
					if (item.active) {
						obj = item
					}
				})
				return obj
			},
			dataItemClick(item, index, e) {
				e.stopPropagation()
				this.clearDataItem()
				this.data[index].active = true
			},
			clearDataItem() {
				this.data.forEach((item) => {
					item.active = false
				})
			},
			getActiveDataItem() {
				let obj = null
				this.data.forEach((item, index) => {
					if (item.active) {
						obj = {
							item: item,
							index: index
						}
					}
				})
				return obj
			},
			checkDataItemUnique(checkItem) {
				let obj = null
				this.data.forEach((item) => {
					if (item.id == checkItem.id) {
						obj = true
					}
				})
				return obj
			},
			toRight() {
				let staff = this.getActiveStaff()
				if (!staff) {
					this.$message.error({
						message: '请选择人员',
					})
				} else {

					let obj = {
						id: staff.id,
						name: staff.name,
						departmentname: this.$refs.onlinedepartmenttree.getdepartmentbyid(staff.departmentid).name,
						departmentid: staff.departmentid,
						active: false,
					}
					if (!this.checkDataItemUnique(obj)) {
						this.data.push(obj)
						this.dataChange()
					} else {
						this.$message.error({
							message: '该选项已存在',
						})
					}

					//console.log(this.currentdepartmentid,relativep)
				}
			},
			toLeft() {
				let obj = this.getActiveDataItem()
				if (obj) {
					this.data.splice(obj.index, 1)
					this.dataChange()
				}
			},
			submitData() {
				return this.data
			},
			setData(data) {
				data.forEach((item) => {
					item.active = false
				})
				this.data = data
			},
			dataChange() {
				this.$emit('datachange', {
					data: this.data,
					type: 'staff'
				})
			},
			flashList() {
				this.createStaff(this.staff)
			}
		},
		components: {
			departmentTree
		}
	}
</script>
